import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../context";

interface DeleteTemplateProps {
  templateId: string;
}

export const useDeleteTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ templateId }: DeleteTemplateProps) => {
      return api({
        method: "DELETE",
        url: `/templates/${templateId}`,
      });
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["templates"] });
      queryClient.invalidateQueries({
        queryKey: ["template", variables.templateId],
      });
    },
  });
};
